import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth/auth.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-pricing',
  templateUrl: './pricing.component.html',
  styleUrls: ['./pricing.component.scss']
})
export class PricingComponent implements OnInit {

  candidatoId: number | null = null;
  isPremium = false;
  loading = false;
  error = '';
  plan: 'monthly' | 'annual' = 'monthly';

  constructor(private http: HttpClient, private router: Router, private authService: AuthService) {}

  ngOnInit(): void {
    const user = this.authService.currentUserValue;
    if (user?.user?.idUsuario) {
      this.candidatoId = user.user.idUsuario;
      this.checkStatus();
    }
  }

  checkStatus(): void {
    this.http.get(`${environment.baseApi}/privado/alertas/estado/${this.candidatoId}`).subscribe({
      next: (res: any) => { this.isPremium = res?.data?.isPremium ?? false; },
      error: () => {}
    });
  }

  suscribir(): void {
    if (!this.candidatoId) {
      this.router.navigate(['/acceder'], { queryParams: { returnUrl: '/planes' } });
      return;
    }
    this.loading = true;
    this.error = '';
    // La moneda la gestiona Stripe con Adaptive Pricing según la IP del comprador
    this.http.post(`${environment.baseApi}/privado/stripe/checkout`, { candidatoId: this.candidatoId, plan: this.plan }).subscribe({
      next: (res: any) => {
        const url = res?.data?.url;
        if (url) { window.location.href = url; }
        else { this.error = 'No se pudo iniciar el pago. Intenta más tarde.'; this.loading = false; }
      },
      error: (e) => {
        this.error = e?.error?.message ?? 'Error al iniciar el pago. Intenta más tarde.';
        this.loading = false;
      }
    });
  }
}
